var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircularCrossIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.001,
    height: 22.001,
    viewBox: "0 0 22.001 22.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 298",
    d: "M8.764 4.09H5.258V.584a.584.584 0 1 0-1.169 0V4.09H.584a.584.584 0 0 0 0 1.169H4.09v3.505a.584.584 0 1 0 1.169 0V5.258h3.505a.584.584 0 0 0 0-1.169z",
    transform: "rotate(45 .223 15.465)",
    style: {
      fill: "#73767c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 299",
    d: "M193.328 1686.447a11 11 0 1 0 11 11 11.013 11.013 0 0 0-11-11zm0 20.244a9.245 9.245 0 1 1 9.244-9.245 9.254 9.254 0 0 1-9.244 9.245z",
    transform: "translate(-182.327 -1686.447)",
    style: {
      fill: "#73767c"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularCrossIcon);
export default __webpack_public_path__ + "static/media/circular-cross-icon.3da4fe38f810bdad58eb71dafbad827b.svg";
export { ForwardRef as ReactComponent };